<nav class="navbar navbar-expand-lg navbar-dark sticky-top" style="border-radius: 25px 0 25px 0;">
  <a href="#" target="_blank" class="text-danger font-weight-light">
    <img src="./../../assets/img/activelogo.webp" width="4%" height="4%" alt="Active Multi Enterprises Logo" class="foot-logo">&nbsp;
    <span class="company-name" style="margin-right: 10px; font-size: 16px; font-weight: bold; color: black;">Active Multi Enterprises</span>
</a>

  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
  </button>
  <div id="navbarNavDropdown" class="navbar-collapse collapse">
      <ul class="navbar-nav mr-auto">
          
      </ul>
      <ul class="navbar-nav">
      <li class="nav-item">  
        <a routerLink="/home-page" class="nav-link text-light active" routerLinkActive="active">  
         Home
        </a>  
      </li>

      <li class="nav-item dropdown">
        <a 
            class="nav-link dropdown-toggle" 
            id="servicesDropdown" 
            aria-expanded="false">
            Services
        </a>
        <ul class="dropdown-menu" aria-labelledby="servicesDropdown">
            <li><a class="dropdown-item" routerLink="/screw-air-compressor" routerLinkActive="active">Multi Brand Screw Air Compressor Service</a></li>
            <li><a class="dropdown-item" routerLink="/piston-compressor" routerLinkActive="active">Multi Brand Piston Compressor Service</a></li>
            <li><a class="dropdown-item" routerLink="/air-dryer" routerLinkActive="active">Multi Brand Air Dryer Service</a></li>
            <li><a class="dropdown-item" routerLink="/water-chiller" routerLinkActive="active">Multi Brand Water Chiller Services</a></li>
            <li><a class="dropdown-item" routerLink="/oil-chiller" routerLinkActive="active">Multi Brand Oil Chiller Service</a></li>
            <li><a class="dropdown-item" routerLink="/panel-air-cooler" routerLinkActive="active">Panel Air Cooler Services</a></li>
            <li><a class="dropdown-item" routerLink="/air-pipe-line" routerLinkActive="active">Air Pipe Line Works</a></li>
        </ul>
    </li>
    
    <li class="nav-item dropdown">
      <a 
          class="nav-link dropdown-toggle" 
          id="servicesDropdown" 
          aria-expanded="false">
          Products
      </a>
      <ul class="dropdown-menu" aria-labelledby="servicesDropdown">
          <li><a class="dropdown-item" routerLink="/screw" routerLinkActive="active">SCREW AIR COMPRESSOR</a></li>
          <li><a class="dropdown-item" routerLink="/piston" routerLinkActive="active">PISTON AIR COMPRESSOR</a></li>
          <li><a class="dropdown-item" routerLink="/airdryer" routerLinkActive="active">AIR DRYER</a></li>
          <li><a class="dropdown-item" routerLink="/airtank" routerLinkActive="active">AIR RECEIVER TANK</a></li>
          <li><a class="dropdown-item" routerLink="/waterchiller" routerLinkActive="active">WATER CHILLER</a></li>
          <li><a class="dropdown-item" routerLink="/oilchiller" routerLinkActive="active">OIL CHILLER</a></li>
          <li><a class="dropdown-item" routerLink="/airaccessories" routerLinkActive="active">AIR ACCESSORIES</a></li>
      </ul>
  </li>
    
      
    
      <li class="nav-item">  
        <a routerLink="/clients" class="nav-link text-light" routerLinkActive="active">  
            Gallery
        </a>  
      </li> 
      <li class="nav-item">  
        <a routerLink="/contact-us" class="nav-link text-light" routerLinkActive="active">  
           Contact
        </a>  
    </li>  
  </ul>  
      <!-- <li class="nav-item">  
        <a routerLink="/about-us" class="nav-link text-light" routerLinkActive="active">  
         About Us 
        </a>  
      </li>  -->
      <!-- <li class="nav-item dropdown active">
          <div class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown">
            Services
          </div>
          <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" routerLink="/custom-software-development">Custom Software Development</a>
              <a class="dropdown-item" routerLink="/web-development">Web Development</a>
              <a class="dropdown-item" routerLink="/mobile-development">Mobile Application Development</a>
              <a class="dropdown-item" routerLink="/web-hosting">Web Hosting, SEO Services</a>
              <a class="dropdown-item" routerLink="/maintenance">Application Maintenance & Support</a>
          </div>
      </li> -->
    
        <!-- <li class="nav-item">  
          <a routerLink="/testimonials" class="nav-link text-light" routerLinkActive="active">  
              Testimonials
          </a>  
        </li>     -->
        <!-- <li class="nav-item dropdown active">
          <div class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown">
            careers
          </div>
          <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" routerLink="/upload-cv">Upload Your CV</a>
          </div>
      </li> -->
      <!-- <li class="nav-item">  
        <a routerLink="/upload-cv" class="nav-link text-light" routerLinkActive="active">  
           Careers
        </a>  
    </li> -->
     
      <!-- <li class="nav-item">
        <a routerLink="/login" class="nav-link text-light" routerLinkActive="active">
          Log-In
        </a>
      </li> -->

  </div>  
</nav>  
  <!-- <router-outlet></router-outlet>   -->
